export const CLOUDINARY_COMPLIANCE_BASE_URL = "https://res.cloudinary.com/drzta9shk/image/upload";
